/* tslint:disable */
/* eslint-disable */
export enum BidType {
  Floor = 'floor',
  Prebid = 'prebid',
  Online = 'online',
  PostSale = 'post_sale'
}
